import Tooltip from "../../../common/Tooltip";
import PaperTypeIcon from "../../../common/PaperTypeIcon";
import ServiceIcon from "../../../common/ServiceIcon";
import { getPaperType, getServiceType, getLineItemServiceType, PAPER_TYPES, SERVICE_TYPES } from "../../../../lib/const";
import { useLabOrderDetailsStore } from "../../../../stores";

const MAX_VISIBLE_ICONS = 10;

const LabOrderPaperService = () => {

  const { order, originalLineItems, multiOpeningLineItems, albumOrderDetails } = useLabOrderDetailsStore()
  const orderAttributes = order?.data?.attributes ?? {}
  const lineItems = [...originalLineItems, ...multiOpeningLineItems, ...albumOrderDetails]
  const usedPapers = [
    ...new Set(
      lineItems.filter(({ attributes }) => attributes.photographType !== 'test-prints').map(({ attributes }) => getPaperType(
        attributes.paperName || attributes.albumPaperName || attributes.printSizeAttributes?.paper
      )).filter(Boolean)
    ),
  ];

  const usedServices = [...new Set([
    ...(orderAttributes.allServices ?? []).map(getServiceType),
    ...(orderAttributes.finishingServices ?? []).map(getServiceType),
    ...lineItems.flatMap(({ attributes, type }) => [
      getLineItemServiceType(attributes, type === 'multi_openings_line_item'),
      attributes.photographType === 'artist-proofs' && SERVICE_TYPES.artist_proof,
      attributes.photographType === 'test-prints' && SERVICE_TYPES.test_print,
    ]),
    (albumOrderDetails.length > 0 || orderAttributes.hasAlbumOrder) && SERVICE_TYPES.albums,
    multiOpeningLineItems.length > 0 && SERVICE_TYPES.multi_openings,
    (orderAttributes.hasCanvas || usedPapers.includes(PAPER_TYPES.canvas)) && SERVICE_TYPES.canvas,
    orderAttributes.hasMat && SERVICE_TYPES.mat,
    orderAttributes.hasMount && SERVICE_TYPES.mount,
    orderAttributes.hasFrame && SERVICE_TYPES.frame,
    orderAttributes.apiOrder && SERVICE_TYPES.api_order,
    (orderAttributes.boutiqueShipping || orderAttributes.isBoutiqueOrder) && SERVICE_TYPES.boutique,
  ].filter(Boolean))];

  return (
    <>
      <div className="w-layout-grid grid-15">
        {usedServices.slice(0, MAX_VISIBLE_ICONS).map((service) => (
          <Tooltip key={service.label} title={service.label}>
            <ServiceIcon classname={service.iconClassname} value={service.abbreviation} />
          </Tooltip>
        ))}
        {usedServices.length > MAX_VISIBLE_ICONS && (
          <Tooltip title={usedServices.slice(MAX_VISIBLE_ICONS).map((service) => service.label).join(', ')}>
            <span style={{ whiteSpace: 'nowrap' }}>+{usedServices.length - MAX_VISIBLE_ICONS} more</span>
          </Tooltip>
        )}
      </div>
      <div className="w-layout-grid grid-15">
        {usedPapers.slice(0, MAX_VISIBLE_ICONS).map((paper) => (
          <Tooltip key={paper.label} title={paper.label}>
            <PaperTypeIcon value={paper.abbreviation} />
          </Tooltip>
        ))}
        {usedPapers.length > MAX_VISIBLE_ICONS && (
          <Tooltip title={usedPapers.slice(MAX_VISIBLE_ICONS).map((paper) => paper.label).join(', ')}>
            <span style={{ whiteSpace: 'nowrap' }}>+{usedPapers.length - MAX_VISIBLE_ICONS} more</span>
          </Tooltip>
        )}
      </div>
    </>
  );
};

export default LabOrderPaperService;
